import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { IActionResult } from '../microsoft/asp-net-core/mvc/models';

@Injectable({
  providedIn: 'root',
})
export class ClassFileDownloadService {
  apiName = 'Default';
  

  downloadFileByClassId = (classId: string) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/app/course-classes/download',
      params: { classId },
    },
    { apiName: this.apiName });
  

  getFileStreamByClassId = (classId: string) =>
    this.restService.request<any, IActionResult>({
      method: 'GET',
      url: '/api/app/course-classes/file-stream',
      params: { classId },
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
